export const GET_REMOVE_STOCK_REASONS = gql`
    query removeStockReasons {
        removeStockReasons {
            id
            description
            createdAt
        }
    }
`;
